import { type ScaleLinear, axisBottom, axisTop, scaleLinear, select } from "d3";
import { Component } from "react";
import ReactDOM from "react-dom";

import { formatNumberByThousands } from "widgets/utils";

import { type Range } from "../../graphql.js";
import { type IBoxModel } from "./interfaces.js";

enum HorizontalAxisType {
  BOTTOM,
  TOP,
}

export interface IHorizontalAxisProps {
  boxModel: IBoxModel;
  domain: Range; // the domain space range
  tickCount: number; // approximate number of ticks
  type: HorizontalAxisType;
}

interface IHorizontalAxisState {
  axis: any;
}
/**
 * Axis with ticks and labels below.
 *
 * created on 11/24/2016
 */
class HorizontalAxis extends Component<IHorizontalAxisProps, IHorizontalAxisState> {
  constructor(props: IHorizontalAxisProps) {
    super(props);

    this.state = {
      axis: this.calculateAxis(),
    };
  }

  calculateAxis = () => {
    const contentWidth =
      this.props.boxModel.width - this.props.boxModel.padding.left - this.props.boxModel.padding.right;

    const scale: ScaleLinear<number, number> = scaleLinear()
      .domain([this.props.domain.start - 1, this.props.domain.stop])
      .range([0, contentWidth]);

    let axis: any = null;
    if (this.props.type === HorizontalAxisType.BOTTOM) {
      axis = axisBottom(scale).ticks(this.props.tickCount);
    } else {
      axis = axisTop(scale).ticks(this.props.tickCount);
    }
    // Don't show zero tick label
    return axis.tickFormat((d: number) => {
      return d === 0 ? "" : formatNumberByThousands(d);
    });
  };

  componentDidMount() {
    this.renderAxis();
  }

  renderAxis = () => {
    const node: Element = ReactDOM.findDOMNode(this) as Element;
    select(node).call(this.state.axis);
  };

  componentDidUpdate(prevProps: IHorizontalAxisProps) {
    if (
      this.props.boxModel !== prevProps.boxModel ||
      this.props.domain !== prevProps.domain ||
      this.props.tickCount !== prevProps.tickCount ||
      this.props.type !== prevProps.type
    ) {
      this.setState({ axis: this.calculateAxis() });
    }

    this.renderAxis();
  }

  render() {
    const translate = `translate(${this.props.boxModel.padding.left},${this.props.boxModel.padding.top - 1})`;
    return <g className="axis" transform={translate} />;
  }
}

export { HorizontalAxisType };
export default HorizontalAxis;
